<template>
  <BFormRadioGroup v-model="theme" :options="themeOptions" buttons size="sm" button-variant="outline-light" />
</template>

<script setup>
import { watch } from 'vue';
import { useStore } from 'vuex';

import { useTheme } from '@/composables/useTheme';

const { theme, setTheme } = useTheme();
const store = useStore();

watch(theme, (newTheme) => {
  setTheme(newTheme);
  store.dispatch('changeTheme', newTheme);
});

const themeOptions = [
  { text: 'Light', value: 'light' },
  { text: 'Dark', value: 'dark' },
  { text: 'Auto', value: 'auto' },
];
</script>
